import { Brightness1 } from "@mui/icons-material";
import { Box, Button } from "@mui/material";
import { ArrowSquareLeft, ArrowSquareRight } from "iconsax-react";
import { useState, useEffect } from "react";
import ContactCard from "./contact-card";

const CardsSlider = ({ contact, settings, update, defaultCard, uiStore }) => {
    const [index, setIndex] = useState(0);

    useEffect(() => {
        if (defaultCard) {
            const def = contact.find(i => i._id === defaultCard);
            const index = contact.indexOf(def)
            if(index !== -1)
                setIndex(index);
        }

    }, [contact, defaultCard]);

    return (
        <Box sx={{ padding: '0 10px', justifyContent: 'center' }}>
            <Box sx={{ m: '0 auto' }}>
                <ContactCard
                    card={contact[index]}
                    settings={settings}
                    defaultCard={defaultCard}
                    update={update}
                    uiStore={uiStore}
                    contacts
                />
            </Box>
            <Box sx={{ display: 'flex', justifyContent: 'space-between' }}>
                <Button disabled={index === 0} onClick={() => setIndex(index - 1)}>
                    <ArrowSquareLeft
                        size="32"
                        variant="Bulk"
                        style={{ marginRight: '10px' }}
                    />
                </Button>
                <Box>
                    {contact.map((s, i) =>
                        <Brightness1
                            key={i}
                            fontSize="10px"
                            htmlColor={i === index ? '#1d1761' : "#e5e5e5"}
                            style={{ margin: '15px 5px 0 5px' }}
                        />
                    )}
                </Box>
                <Button disabled={index >= contact.length - 1} onClick={() => setIndex(index + 1)}>
                    <ArrowSquareRight
                        size="32"
                        variant="Bulk"
                        style={{ marginLeft: '10px' }}
                    />
                </Button>
            </Box>
        </Box>
    );
}

export default CardsSlider;